import React from "react";
import { Link } from "react-router-dom";
import playStoreLogo from "../../../assets/google_play.png"
import {
  COPYRIGHT_TEXT,
  BRAND_COLOR,
  TEXT_COLOR_WHITE,
} from "../../../common/constants";

import {
  FaYoutube,
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
  FaLinkedin
} from "react-icons/fa";

import "./Footer.css";

const Footer = () => {
  return (
    <footer
      className="footer"
      id="contact"
      style={{
        "--brand-color": BRAND_COLOR,
        "--text-white": TEXT_COLOR_WHITE,
      }}
    >
      {/* ================= MAIN FOOTER ================= */}
      <div className="footer-container">

        {/* ===== BRAND INFO ===== */}
        <div>
          <h4>Speak Bold with KK</h4>
          <p style={{ fontSize: 14, lineHeight: 1.7, opacity: 0.9 }}>
            Speak Bold with KK helps you build confidence in communication
            through live sessions, group discussions, and expert-guided
            practice.
          </p>
        </div>

        {/* ===== QUICK LINKS ===== */}
        <div>
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/timetable" className="footer-link">
                Live Sessions
              </Link>
            </li>
            <li>
              <Link to="/plans" className="footer-link">
                Subscription Plans
              </Link>
            </li>
            <li>
              <Link to="/faqs" className="footer-link">
                FAQs
              </Link>
            </li>
          </ul>
        </div>

        {/* ===== SUPPORT ===== */}
        <div>
          <h4>Support</h4>
          <ul>
            <li>
              <Link to="/privacy-policy" className="footer-link">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="footer-link">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/cancellation-refund" className="footer-link">
                Cancellation & Refund Policy
              </Link>
            </li>
            <li>
              <Link to="/shipping-policy" className="footer-link">
                Shipping & Delivery Policy
              </Link>
            </li>
          </ul>
        </div>
        



        {/* ===== CONTACT ===== */}
        <div className="footer-contact">
          <h4>Get in Touch</h4>
          <p>📧 support@speakboldwithkk.com</p>
          <p>📍 India (Online Sessions)</p>

          <Link to="/support" className="footer-link">
            Contact Us →
          </Link>
        </div>


        {/* ===== SOCIAL ===== */}
        <div className="footer-social">
          <h4>Follow Us</h4>
          <div className="footer-icons">

            <a
              href="https://in.linkedin.com/company/speak-bold-with-kk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>

            <a
              href="https://youtube.com/@speakboldwithkk?si=ppwIrXH8-Ro1pIkp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>

            <a
              href="https://www.instagram.com/speakboldwithkk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.facebook.com/share/1CG8kFK9tj/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>

             <a
      href="https://whatsapp.com/channel/0029Vb7d3xQ7oQhd646Yp736" // replace with your number in international format
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </a>
          </div>

 {/* ===== ANDROID APP ===== */}
          <h4 style={{ marginTop: 20 }}>Get SpeakBold Club App</h4>
          <a
            href="https://play.google.com/store/apps/details?id=com.kktech.kmdialogues&pcampaignid=web_share" // replace with your Play Store URL
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-block", marginTop: 6 }}
          >
            <img
              src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
              alt="Get it on Google Play"
              style={{ height: 40 }}
            />
          </a>


        </div>

      </div>

      {/* ================= BOTTOM BAR ================= */}
<div
  style={{
    marginTop: 40,
    paddingTop: 20,
    borderTop: "1px solid rgba(255,255,255,0.25)",
    textAlign: "center",
    fontSize: 13,
    opacity: 0.85,
  }}
>
  <p>{COPYRIGHT_TEXT}</p>
  <p style={{ marginTop: 6 }}>Designed for confident conversations 🚀</p>
  <p style={{ marginTop: 6 }}>
    <a
      href="https://in.linkedin.com/company/speak-bold-with-kk"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#00ffffff", textDecoration: "none", fontWeight: "bold" }}
    >
      LinkedIn
    </a>{" "}
    |{" "}
    <a
      href="https://youtube.com/@speakboldwithkk?si=ppwIrXH8-Ro1pIkp"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#00ffffff", textDecoration: "none", fontWeight: "bold" }}
    >
      YouTube
    </a>{" "}
    |{" "}
    <a
      href="https://www.instagram.com/speakboldwithkk"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#00ffffff", textDecoration: "none", fontWeight: "bold" }}
    >
      Instagram
    </a>{" "}
    |{" "}
    <a
      href="https://www.facebook.com/share/1CG8kFK9tj/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#00ffffff", textDecoration: "none", fontWeight: "bold" }}
    >
      Facebook
    </a>{" "}
    |{" "}
    <a
      href="https://whatsapp.com/channel/0029Vb7d3xQ7oQhd646Yp736"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#00ffffff", textDecoration: "none", fontWeight: "bold" }}
    >
      WhatsApp
    </a>
  </p>
</div>


    </footer>
  );
};

export default Footer;
